module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/sortArrow.ae6f2ddc.svg";